import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Paper,
  Typography,
  IconButton,
  Box,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
import PushPinIcon from "@mui/icons-material/PushPin";

const QuestionsDialog = ({
  openQuestionList,
  handleCloseQuestionList,
  getAllReadingQuestions,
  navigateToQuestion,
  answers,
  markedQuestions = {},
}) => {
  return (
    <Dialog
      open={openQuestionList}
      onClose={handleCloseQuestionList}
      maxWidth="md"
      PaperProps={{
        sx: { borderRadius: 2, p: 1 },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "1.25rem",
          fontWeight: 500,
        }}
      >
        Questions
        <IconButton onClick={handleCloseQuestionList} size="small">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 1.5,
            maxWidth: 600,
            maxHeight: 400,
            overflow: 'auto',
            p: 1,
            justifyContent: 'flex-start',
          }}
        >
          {getAllReadingQuestions.map((question) => {
            const isAnswered = !!answers[question._id];
            const isMarked = !!markedQuestions[question._id];
            return (
              <Box key={question._id} sx={{ position: "relative" }}>
                <Paper
                  elevation={0}
                  onClick={() => navigateToQuestion(question.number)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 48,
                    height: 48,
                    minWidth: 48,
                    cursor: "pointer",
                    border: "1px solid",
                    borderColor: isAnswered ? "success.main" : "divider",
                    bgcolor: isAnswered ? "success.light" : "background.paper",
                    color: isAnswered ? "white" : "text.primary",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                      bgcolor: isAnswered ? "success.main" : "primary.light",
                      color: "white",
                      boxShadow: 2,
                    },
                    fontWeight: "bold",
                    borderRadius: "50%",
                  }}
                >
                  {question.number}
                </Paper>
                {isMarked && (
                  <PushPinIcon
                    fontSize="small"
                    sx={{
                      position: "absolute",
                      top: -6,
                      right: -6,
                      color: "warning.main",
                      borderRadius: "50%",
                      fontSize: 18,
                      pointerEvents: "none",
                      filter: "drop-shadow(0 1px 2px rgba(0,0,0,0.2))",
                      rotate: "45deg",
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Box>
        <Box sx={{ mt: 2, display: "flex", gap: 3, alignItems: "center", flexWrap: "wrap" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Paper
              sx={{
                width: 20,
                height: 20,
                bgcolor: "success.light",
                borderColor: "success.main",
                border: "1px solid",
                borderRadius: "50%",
              }}
            />
            <Typography variant="body2">Answered</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Paper
              sx={{
                width: 20,
                height: 20,
                bgcolor: "background.paper",
                borderColor: "divider",
                border: "1px solid",
                borderRadius: "50%",
              }}
            />
            <Typography variant="body2">Not answered</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PushPinIcon sx={{ color: "warning.main", fontSize: 20 }} />
            <Typography variant="body2">Marked for review</Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default QuestionsDialog;
